import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { Modal } from "../../../../theme/Component/Modal";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Singleton } from "../../../../../core/services/Singleton";
import { SelectTrdsID } from "../../../../admin/configuracion/TrdID/SelectTrdsID";
import { _PayrollDocumentType } from "../../../../../core/services/dataBean/EntityCatalogVdos";



export const PayrollDocumentType = () => {

    const PayrollDocumentType = useDataBean(_PayrollDocumentType);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        PayrollDocumentType.instance.getPayrollDocumentTypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        PayrollDocumentType.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        PayrollDocumentType.deleteItemVoid(PayrollDocumentType.bean.IDPayrollDocumentType).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        PayrollDocumentType.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDPayrollDocumentType', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Tabla de Retención Documental', property: 'IDLnTrd', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${PayrollDocumentType.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipos de Documentos Laborales">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={PayrollDocumentType.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={PayrollDocumentType.bean.Name} onChange={PayrollDocumentType.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <SelectTrdsID edit={false} trdIDLn={PayrollDocumentType.bean.IDLnTrd} onChange={(e: any) => { PayrollDocumentType.setBean({ ...PayrollDocumentType.bean, "IDLnTrd": e.IDLn }) }}></SelectTrdsID>
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <input type="text" name="Description" className="form-control" value={PayrollDocumentType.bean.Description} onChange={PayrollDocumentType.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {PayrollDocumentType.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}